import { RadioButtonGroup } from "react-rainbow-components";
import styled from "styled-components";

import PreFooter from "./PreFooter";
import Footer from "./Footer";
import { useState } from "react";
import OutsideIran from "../reserve Items/OutsideIran";
import InsideIran from "../reserve Items/insideIran";
import MobileHeader from './mobile/MobileHeader';

const PlaneTicket = () => {
  const [value, setValue] = useState('insideIran');

  const options = [
    { value: "iranOut", label: "پرواز خارجی" },
    { value: "insideIran", label: "پرواز داخلی" },
  ];

  const handleOnChange = (e) => {
    setValue(e.target.value);
  };
  return (
    <>
      <MobileHeader />
      <div>
        <RadioButtonGroup
          id="radio-button-group-component-1"
          options={options}
          value={value}
          onChange={handleOnChange}
          size="small"
          variant="brand"
          className="SelectOption"
        />
      </div>

      <div>{value === "iranOut" ? <OutsideIran /> : <InsideIran />}</div>
      <PreFooter />
      <Footer />
    </>
  );
};

export default PlaneTicket;
